import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { moment, get_current_datetime } from '../utils/datetime';
import { USER_INFO, TOKEN, DB_TOKEN } from '../constants/storage-keys';
import { clearIDB } from '../services/indexedDB';
import { TSectionRestriction } from '../types/staff';
export enum ERole {
  staff = 'staff',
  admin = 'admin',
}
export interface IUser {
  name: string;
  profile_pic: string;
  token: string;
  token_exp_time: string;
  datastore_key:string;
  user_id: number;
  clinic_id: number;
  clinic_name: string;
  mobile: string;
  role: ERole | '';
  display_role:string;
  clinic_settings: any | null,
  clinic_website:string;
  clinic_lat:string;
  clinic_lng:string;
  clinic_district:string,
  clinic_state:string,
  crm_name: string | null,
  crm_contact_number: string | null,
  restricted_sections: TSectionRestriction[] | null,
}
export interface IinitialState {
  isLoggedin: boolean;
  user: IUser;
  token: string | null;
  db_token: string | null;
}

const STORAGE_USER_INFO = localStorage.getItem(USER_INFO);
const STORAGE_TOKEN = localStorage.getItem(TOKEN);
const staorage_db_token = localStorage.getItem(DB_TOKEN);
const checkSession = () => {
  if (STORAGE_USER_INFO && STORAGE_TOKEN) {
    let userinfo: IUser = JSON.parse(STORAGE_USER_INFO);
    if (moment(userinfo.token_exp_time) <= moment(get_current_datetime())) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

const initialState: IinitialState = {
  isLoggedin: checkSession(),
  user: STORAGE_USER_INFO
    ? JSON.parse(STORAGE_USER_INFO)
    : { name: '', token: '', clinic_id: 0, mobile: '', role: '' },
  token: STORAGE_TOKEN,
  db_token:staorage_db_token
};

const authentication = createSlice({
  name: 'authentication',
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<IUser>) => {
      state.isLoggedin = true;
      state.user = action.payload;
      state.token = action.payload.token;
      state.db_token = action.payload.datastore_key;
      localStorage.setItem(USER_INFO, JSON.stringify(action.payload));
      localStorage.setItem(TOKEN, action.payload.token);
      localStorage.setItem(DB_TOKEN, action.payload.datastore_key);
    },
    logout: (state) => {
      localStorage.clear();
      clearIDB();
      state.isLoggedin = false;
      state.user = {
        name: '',
        token: '',
        datastore_key:"",
        clinic_id: 0,
        mobile: '',
        role: '',
        display_role:'',
        clinic_name: '',
        profile_pic: '',
        token_exp_time: '',
        user_id: 0,
        clinic_settings: {},
        clinic_website:"",
        clinic_lat:"",
        clinic_lng:"",
        clinic_district:"",
        clinic_state:"",
        crm_name: null,
        crm_contact_number: null,
        restricted_sections: null
      };
      state.token = '';
    },
  },
});

export const { login, logout } = authentication.actions;

export default authentication.reducer;
